import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SAVE_NEW_EXTRA } from '../actions/actionsTypes';
import { postDataWithHeaders } from '../httpClient';
import { SaveExtraActionType } from '../actions/saveExtraAction';
import { resetUser } from '../slices/userSlice/userSlice';

export function* saveExtra(action: SaveExtraActionType): any {
  try {
    yield call(postDataWithHeaders, '/api/v1/admin/extras', action.headers, {
      kind: action.kind,
      price: action.price,
      active: true,
    });
    if (action.onSuccess) {
      action.onSuccess();
    }
  } catch (e: any) {
    if (e?.status === 401) {
      yield put(resetUser());
      alert('Sorry, Login Expired! Please Login again');
    } else {
      alert('Failed to save Extra');
    }
  }
}

export function* watchSaveExtra() {
  yield takeEvery(SAVE_NEW_EXTRA, saveExtra);
}
